// Localization keys for evaluation metrics
export const EVALUATION_METRIC_KEYS = {
  ACCURACY: "accuracy",
  GINI: "gini",
  AUC: "auc",
  COVERAGE: "coverage",
  F1_SCORE: "f1_score",
  RECALL_SCORE: "recall_score",
  PRECISION_SCORE: "precision_score",
} as const

// Function to get localized metric names
export const getLocalizedMetricNames = (t: (key: string) => string): string[] => {
  return [
    t(EVALUATION_METRIC_KEYS.ACCURACY),
    t(EVALUATION_METRIC_KEYS.GINI),
    t(EVALUATION_METRIC_KEYS.AUC),
    t(EVALUATION_METRIC_KEYS.COVERAGE),
    t(EVALUATION_METRIC_KEYS.F1_SCORE),
    t(EVALUATION_METRIC_KEYS.RECALL_SCORE),
    t(EVALUATION_METRIC_KEYS.PRECISION_SCORE),
  ]
}
